import React from "react"
import Assignation from "../../../models/Assignation"
import EntityDetails from "../Utils/EntityDetails"
import AssignationCreaLinkEdit from "./AssignationCreaLinkEdit"
import AssignationCreaLinkOpen from "./AssignationCreaLinkOpen"

interface AssignationCreaLinkProps {
    assignation: Assignation
}

const AssignationCreaLink: React.FC<AssignationCreaLinkProps> = ({ assignation }) => (
    <EntityDetails
        title="Link a CREA"
        entity={assignation}
        rows={[
            ['Link aula CREA', 'creaLink']
        ]}
        gadgets={<>
            <AssignationCreaLinkOpen link={assignation.creaLink} />
            <AssignationCreaLinkEdit assignation={assignation} />
        </>}
    />

)

export default AssignationCreaLink